<template>
  <b-input-group size="sm" class="mb-1">
    <b-form-input
      :placeholder="myplaceholder"
      debounce="500"
      id="filter-input"
      v-model="search"
      type="search"
    ></b-form-input>
    <b-input-group-append>
      <b-button :disabled="!search" @click="search = ''">清除</b-button>
    </b-input-group-append>
  </b-input-group>
</template>

<script>
export default {
  props: ['myplaceholder'],
  data () {
    return {
      search: ''
    }
  },
  watch: {
    search () {
      this.$emit('searchChange', this.search)
    }
    // searchOut () {
    //   this.search = this.searchOut
    // }
  }
}
</script>
